import {
  validateSignUp,
  validateLogin,
  validateVerificationCode,
  validateForgotPassword,
  validateResetPassword,
} from "../../../utils/validation/registrationValidation";

import {
  validatePersonalInfo,
  validatePracticeDetails,
  validateDocumentsDetail,
  validateSignatureDetail,
  validateBankAccountDetail,
  validateSubscription,
} from "../../../utils/validation/onboardingValidation";

import {
  validateAvailabilitySchedule,
  validateChangePassword,
  validateTemplates,
} from "../../../utils/validation/dashboardValidations";

import {
  VALIDATE_LOGIN,
  VALIDATE_SIGNUP,
  VERIFY_EMAIL,
  VALIDATE_FOROGOT_PASSWORD,
  VALIDATE_RESET_PASSWORD,
  VALIDATE_PERSONALINFO,
  VALIDATE_PRACTICEDETAILS,
  VALIDATE_DOCUMENTS,
  VALIDATE_SIGNATURE,
  VALIDATE_CHANGE_PASSWORD,
  VALIDATE_AVAILABILITY_SCHEDULE,
  REMOVE_VALIDATIONS,
  VALIDATE_PATIENT_PERSONAL_INFO,
  VALIDATE_TEMPLATE,
  VALIDATE_PATIENT_DOCUMENT_INFO,
  VALIDATE_ACH_BANK_DETAILS,
  VALIDATE_PATIENT_CONTACT_INFO,
  VALIDATE_PATIENT_DOSESPOT_PROFILE,
  VALIDATE_SUBSCRIPTION,
} from "../../actions/actionTypes";

import {
  validatePatientPersonalInfo,
  validatePatientDocumentInfo,
  validatePatientContactInfo,
  validatePatientDoseSpotProfile,
} from "../../../utils/validation/onboardingPatientValidation";

const validation = (form = { data: {} }, action) => {
  switch (action.type) {
    case VALIDATE_SIGNUP:
      return { ...form, data: validateSignUp(action.payload) };
    case VALIDATE_LOGIN:
      return { ...form, data: validateLogin(action.payload) };
    case VERIFY_EMAIL:
      return { ...form, data: validateVerificationCode(action.payload) };
    case VALIDATE_FOROGOT_PASSWORD:
      return { ...form, data: validateForgotPassword(action.payload) };
    case VALIDATE_RESET_PASSWORD:
      return { ...form, data: validateResetPassword(action.payload) };
    case VALIDATE_PERSONALINFO:
      return { ...form, data: validatePersonalInfo(action.payload) };
    case VALIDATE_PRACTICEDETAILS:
      return { ...form, data: validatePracticeDetails(action.payload) };
    case VALIDATE_DOCUMENTS:
      return { ...form, data: validateDocumentsDetail(action.payload) };
    case VALIDATE_SIGNATURE:
      return { ...form, data: validateSignatureDetail(action.payload) };
    case VALIDATE_SUBSCRIPTION:
      return { ...form, data: validateSubscription(action.payload) };
    case VALIDATE_CHANGE_PASSWORD:
      return { ...form, data: validateChangePassword(action.payload) };
    case VALIDATE_AVAILABILITY_SCHEDULE:
      return { ...form, data: validateAvailabilitySchedule(action.payload) };
    case VALIDATE_PATIENT_PERSONAL_INFO:
      return { ...form, data: validatePatientPersonalInfo(action.payload) };
    case VALIDATE_PATIENT_DOCUMENT_INFO:
      return { ...form, data: validatePatientDocumentInfo(action.payload) };
    case VALIDATE_TEMPLATE:
      return { ...form, data: validateTemplates(action.payload) };
    case VALIDATE_ACH_BANK_DETAILS:
      return { ...form, data: validateBankAccountDetail(action.payload) };
    case VALIDATE_PATIENT_CONTACT_INFO:
      return { ...form, data: validatePatientContactInfo(action.payload) };
    case VALIDATE_PATIENT_DOSESPOT_PROFILE:
      return { ...form, data: validatePatientDoseSpotProfile(action.payload) };
    case REMOVE_VALIDATIONS:
      return { ...form, data: {} };
    default:
      return form;
  }
};

export default validation;
